import { styled } from 'styled-components';
import { LIST_MAX_HEIGHT, ITEM_HEIGHT } from './constants.js';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const InputWrapper = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
  & > *:first-child {
    flex: auto;
  }
`;
export const ListWrapper = styled.div `
  position: relative;
  overflow: hidden;
  border: ${({ $error, theme }) => `1px solid ${$error ? theme.colors.critical100 : theme.colors.grey30_1}`};
  border-radius: 8px;
  ${({ theme, $error }) => $error && theme.shadows.error};
  background-color: ${({ theme }) => theme.colors.grey00_7};
`;
export const ListHeader = styled.div `
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  ${({ theme }) => theme.typography.weightDefault};
  background-color: ${({ theme }) => theme.colors.grey05_1};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey30_1}`};
  border-radius: 8px 8px 0 0;
`;
export const ListHeaderTitle = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const List = styled.div `
  width: 100%;
  min-height: ${({ $minHeight }) => ($minHeight ? `${ITEM_HEIGHT}px` : '0')};
  height: ${({ $selectedLength }) => $selectedLength * ITEM_HEIGHT}px;
  max-height: ${LIST_MAX_HEIGHT}px;
  overflow-y: auto;
`;
export const ListItem = styled.div `
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey10_1}`};
  background-color: ${({ theme, $isPlaceholder }) => ($isPlaceholder ? theme.colors.grey01_1 : theme.colors.grey00_6)};
  cursor: ${({ $isPlaceholder, $isClickable }) => ($isPlaceholder || $isClickable ? 'pointer' : 'default')};
`;
export const ListFooter = styled.div `
  ${({ theme }) => theme.typography.weightMedium};
  ${({ theme }) => theme.typography.textSmall};
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top: 1px solid ${({ theme }) => theme.colors.grey30_1};
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  margin-top: -1px;
`;
export const Total = styled.div `
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const SortOrderWrapper = styled.div `
  cursor: pointer;
`;
export const Placeholder = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  padding: 8px;
  align-items: center;
  justify-content: center;
`;
export const SuggestionsHeader = styled.div `
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px 4px;
  ${({ theme }) => theme.typography.textSmall};
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const SuggestionsLabel = styled.span `
  color: ${({ theme }) => theme.colors.main};
`;
export const SuggestionsOptions = styled.ul `
  margin: 0;
  padding: 0 0 4px;
  list-style: none;
`;
export const SuggestionsOption = styled.li `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.black_1};
  background: ${({ theme, $isActive }) => ($isActive ? theme.colors.grey01_1 : 'transparent')};
`;
export const SuggestionsOptionHint = styled.span `
  ${({ theme }) => theme.typography.textSmall};
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const SuggestionsEmpty = styled.div `
  padding: 8px 16px 12px;
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const SuggestionsLoader = styled.div `
  padding: 8px 16px 12px;
`;
